export default "__VITE_ASSET__DOyV0NSA__"